import { render, staticRenderFns } from "./ParticipantCounter.vue?vue&type=template&id=81a3285a"
import script from "./ParticipantCounter.vue?vue&type=script&lang=js"
export * from "./ParticipantCounter.vue?vue&type=script&lang=js"
import style0 from "./ParticipantCounter.vue?vue&type=style&index=0&id=81a3285a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a3285a')) {
      api.createRecord('81a3285a', component.options)
    } else {
      api.reload('81a3285a', component.options)
    }
    module.hot.accept("./ParticipantCounter.vue?vue&type=template&id=81a3285a", function () {
      api.rerender('81a3285a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/ParticipantCounter.vue"
export default component.exports